module.exports = __webpack_public_path__ + "img/fusebox_online_logo.835deef1.svg";